// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1fGVa","info":"Note_info__9sFhT","note":"Note_note__29C-k","actions":"Note_actions__k5YJi"};